import Auth0Client from './auth0Client';

export default Auth0Client;
